import { BigNumber } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctTupleArray, FctValueList } from '../../../../Fct/generics';
import { kiroboMulticallContracts } from '../constants';
// {
//   to: new FctAddress({}),
//   value: new FctValue({}),
// }
export var TrasnfersCSV = createPlugin({
    protocol: 'KIROBO_MULTICALL_CSV',
    type: 'LIBRARY',
    toEns: '@lib:multicall',
    method: 'transfers',
    name: 'trasnfersCSV',
    supportedContracts: kiroboMulticallContracts,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    'transfers_tuple[]': new FctTupleArray({ params: { to: new FctAddressList({}), value: new FctValueList({}) } }),
                },
            },
            output: {},
        });
    },
    estimateGasOnParams: function (params, method, chainId) {
        var transfers = params.methodParams['transfers_tuple[]'];
        if (!transfers.value || !Array.isArray(transfers.value)) {
            return '10000';
        }
        var gas = BigNumber.from(transfers.value.length).mul(36000);
        if (chainId === '42161') {
            gas = gas.mul(13);
        }
        return gas.toString();
    },
});
